import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  CardMedia,
} from '@mui/material';
import Footer from '../navbar/Footer';

const bulletinsEtatCivilData = [
  {
    title: 'Bulletin trimestriel des statistiques des faits d’état civil - Trimestre 3, 2015, cas de la Mairie de Bujumbura',
    link: '/documents/Bulletins/FSETC-final-avril-2017.pdf',
    date: new Date('2017-04-01'),
    description: 'La présentantion des statistiques de naissance, mariage, décè et autres faits d’état civil pour le troisième trimestre 2015. cas de la Mairie de Bujumbura',
    image: 'assets/Bulletins/FSTIC-final-2017.PNG',
  },
];

function BulletinsEtatCivil() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsEtatCivilData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredBulletins(bulletinsEtatCivilData);
      setVisibleCount(4);
    } else {
      const filtered = bulletinsEtatCivilData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered);
      setVisibleCount(4);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#f50057',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 'bold',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.03)',
              boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '50px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Bulletins trimestriels des statistiques des faits d’état civil
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1" align="justify" gutterBottom>
            Cette section présente les statistiques trimestrielles des faits d’état civil, incluant les naissances, mariages, décès, et autres événements démographiques.
          </Typography>

          {/* Filtre par année */}
          <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
              variant="outlined"
            >
              <MenuItem value="Tous">Tous les bulletins</MenuItem>
              {[...new Set(bulletinsEtatCivilData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort()
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des bulletins */}
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={12} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'row', height: '200px' }}>
                  <a href={bulletin.link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 151, height: 200, m: 2 }}
                      image={bulletin.image}
                      alt={bulletin.title}
                     
                    />
                  </a>
                  <CardContent style={{ flex: 1, padding: '20px' }}>
                  <a href={bulletin.link} target="_blank"   rel="noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <Typography
                      variant="h6"
                      component="a"
                      href={bulletin.link} 
                      style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main, textDecoration: 'none' }}
                    >
                      {<DownloadIcon />}{bulletin.title}
                    </Typography>
                    </a>
                    <Typography variant="body2" component="div" style={{ marginBottom: '20px', color: '#555' }}>
                      {bulletin.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Bouton "Plus bulletins" */}
          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Bulletins
            </Button>
          )}
        </Container>

        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default BulletinsEtatCivil;